/* eslint-disable  */
import React, { useState, useEffect, useCallback } from 'react';
import { FaChevronCircleUp, FaChevronCircleDown, FaPlay, FaHome, FaAngleLeft, FaHandMiddleFinger, FaSleigh } from 'react-icons/fa';
import { VscDebugRestart } from 'react-icons/vsc';





import { connectWebSocket } from '../../lib/cmra-data-collection';

import Blocks from '../../containers/blocks.jsx';
import UnityPane from '../../containers/unity-pane.jsx';
import styles from './cdg1_gui.css';

import { saveLocalProject, getProject, clearStore } from '../../lib/cmra-local-store';
import { setProjectUnchanged } from "../../reducers/project-changed";
import { updateToolbox } from "../../reducers/toolbox";
import { makeP3GBayToolboxXML } from '../../lib/toolbox/p3g_toolbox';
import { useDispatch, useSelector } from "react-redux";
import VirtualMachine from '@carnegie-mellon-robotics-academy/scratch-vm';

import { getToolboxes } from '../../lib/toolbox/cdg3v2_toolbox';

export const CDG1 = ({ layout, canUseCloud, blocksTabVisible, basePath, vm, stageSizeMode, scratchGui }) => {

  const [isUnityFullScreen, setUnityFullScreen] = useState(true);
  const [unityWidth, setUnityWidth] = useState(960 / 3);
  const [unityHeight, setUnityHeight] = useState(600 / 3);
  const [hideMenu, setHideMenu] = useState(true);
  const [toolbox, setToolbox] = useState(null);
  const [blocklyWorkspace, setBlocklyWorkspace] = useState(null);
  const [programKey, setProgramKey] = useState("cmra_song_id_0");



  const beatCityPrograms = [
    { "targets": [{ "isStage": true, "name": "Stage", "variables": { "`jEk@4|i[#Fk?(8x)AV.-my variable": ["my variable", 0] }, "lists": {}, "broadcasts": {}, "blocks": { "KN)#*$^cjUye;MOubz$!": { "opcode": "cdg3v2_events_when_signal", "next": ")6i6KP;:!2qN`2:{O2+k", "parent": null, "inputs": {}, "fields": {}, "shadow": false, "movable_": false, "topLevel": true, "editable_": false, "x": 40, "y": 66 }, "I]9%_|ACeJfXD(!SW!!y": { "opcode": "cdg3v2_placeholder", "next": null, "parent": null, "inputs": {}, "fields": {}, "shadow": true, "topLevel": true, "x": 40, "y": 266 }, ")6i6KP;:!2qN`2:{O2+k": { "opcode": "cdg3v2_placeholder", "next": null, "parent": "KN)#*$^cjUye;MOubz$!", "inputs": {}, "fields": {}, "shadow": true, "topLevel": false } }, "comments": {}, "currentCostume": 0, "costumes": [{ "assetId": "cd21514d0531fdffb22204e0ec5ed84a", "name": "backdrop1", "md5ext": "cd21514d0531fdffb22204e0ec5ed84a.svg", "dataFormat": "svg", "rotationCenterX": 240, "rotationCenterY": 180 }], "sounds": [{ "assetId": "83a9787d4cb6f3b7632b4ddfebf74367", "name": "pop", "dataFormat": "wav", "format": "", "rate": 44100, "sampleCount": 1032, "md5ext": "83a9787d4cb6f3b7632b4ddfebf74367.wav" }], "volume": 100, "tempo": 60, "videoTransparency": 50, "videoState": "on", "textToSpeechLanguage": null }], "monitors": [], "extensions": [], "meta": { "semver": "3.0.0", "vm": "0.7.9", "agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/98.0.4758.102 Safari/537.36" } },
    
    {"targets":[{"isStage":true,"name":"Stage","variables":{"`jEk@4|i[#Fk?(8x)AV.-my variable":["my variable",0]},"lists":{},"broadcasts":{},"blocks":{"0{`(S/(d[A8eQ4%jJ5Wc":{"opcode":"cdg3v2_events_when_obstacle","next":"P^IMp=(4b7;l02@aR~j1","parent":null,"inputs":{},"fields":{},"shadow":false,"topLevel":true,"x":10,"y":55},"P^IMp=(4b7;l02@aR~j1":{"opcode":"cdg3v2_placeholder","next":null,"parent":"0{`(S/(d[A8eQ4%jJ5Wc","inputs":{},"fields":{},"shadow":true,"topLevel":false}},"comments":{},"currentCostume":0,"costumes":[{"assetId":"cd21514d0531fdffb22204e0ec5ed84a","name":"backdrop1","md5ext":"cd21514d0531fdffb22204e0ec5ed84a.svg","dataFormat":"svg","rotationCenterX":240,"rotationCenterY":180}],"sounds":[{"assetId":"83a9787d4cb6f3b7632b4ddfebf74367","name":"pop","dataFormat":"wav","format":"","rate":44100,"sampleCount":1032,"md5ext":"83a9787d4cb6f3b7632b4ddfebf74367.wav"}],"volume":100,"tempo":60,"videoTransparency":50,"videoState":"on","textToSpeechLanguage":null}],"monitors":[],"extensions":[],"meta":{"semver":"3.0.0","vm":"0.7.9","agent":"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/98.0.4758.102 Safari/537.36"}},

    {"targets":[{"isStage":true,"name":"Stage","variables":{"`jEk@4|i[#Fk?(8x)AV.-my variable":["my variable",0]},"lists":{},"broadcasts":{},"blocks":{"KN)#*$^cjUye;MOubz$!":{"opcode":"cdg3v2_events_when_signal","next":"iI(Kp,3+TE#nCuJfuaVL","parent":null,"inputs":{},"fields":{},"shadow":false,"topLevel":true,"x":10,"y":55},"S:xz2uMOS_asJmx^x-eb":{"opcode":"cdg3v2_events_when_obstacle","next":"7dYc*!oOC!Ok)[f]:oYx","parent":null,"inputs":{},"fields":{},"shadow":false,"topLevel":true,"x":274,"y":55},"iI(Kp,3+TE#nCuJfuaVL":{"opcode":"cdg3v2_placeholder","next":null,"parent":"KN)#*$^cjUye;MOubz$!","inputs":{},"fields":{},"shadow":true,"topLevel":false},"7dYc*!oOC!Ok)[f]:oYx":{"opcode":"cdg3v2_placeholder","next":null,"parent":"S:xz2uMOS_asJmx^x-eb","inputs":{},"fields":{},"shadow":true,"topLevel":false}},"comments":{},"currentCostume":0,"costumes":[{"assetId":"cd21514d0531fdffb22204e0ec5ed84a","name":"backdrop1","md5ext":"cd21514d0531fdffb22204e0ec5ed84a.svg","dataFormat":"svg","rotationCenterX":240,"rotationCenterY":180}],"sounds":[{"assetId":"83a9787d4cb6f3b7632b4ddfebf74367","name":"pop","dataFormat":"wav","format":"","rate":44100,"sampleCount":1032,"md5ext":"83a9787d4cb6f3b7632b4ddfebf74367.wav"}],"volume":100,"tempo":60,"videoTransparency":50,"videoState":"on","textToSpeechLanguage":null}],"monitors":[],"extensions":[],"meta":{"semver":"3.0.0","vm":"0.7.9","agent":"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/98.0.4758.102 Safari/537.36"}},
    
    { "targets": [{ "isStage": true, "name": "Stage", "variables": { "`jEk@4|i[#Fk?(8x)AV.-my variable": ["my variable", 0] }, "lists": {}, "broadcasts": {}, "blocks": { "KN)#*$^cjUye;MOubz$!": { "opcode": "cdg3v2_events_when_signal", "next": ")6i6KP;:!2qN`2:{O2+k", "parent": null, "inputs": {}, "fields": {}, "shadow": false, "movable_": false, "topLevel": true, "editable_": false, "x": 40, "y": 66 }, "I]9%_|ACeJfXD(!SW!!y": { "opcode": "cdg3v2_placeholder", "next": null, "parent": null, "inputs": {}, "fields": {}, "shadow": true, "topLevel": true, "x": 40, "y": 266 }, ")6i6KP;:!2qN`2:{O2+k": { "opcode": "cdg3v2_placeholder", "next": null, "parent": "KN)#*$^cjUye;MOubz$!", "inputs": {}, "fields": {}, "shadow": true, "topLevel": false } }, "comments": {}, "currentCostume": 0, "costumes": [{ "assetId": "cd21514d0531fdffb22204e0ec5ed84a", "name": "backdrop1", "md5ext": "cd21514d0531fdffb22204e0ec5ed84a.svg", "dataFormat": "svg", "rotationCenterX": 240, "rotationCenterY": 180 }], "sounds": [{ "assetId": "83a9787d4cb6f3b7632b4ddfebf74367", "name": "pop", "dataFormat": "wav", "format": "", "rate": 44100, "sampleCount": 1032, "md5ext": "83a9787d4cb6f3b7632b4ddfebf74367.wav" }], "volume": 100, "tempo": 60, "videoTransparency": 50, "videoState": "on", "textToSpeechLanguage": null }], "monitors": [], "extensions": [], "meta": { "semver": "3.0.0", "vm": "0.7.9", "agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/98.0.4758.102 Safari/537.36" } },
  
    { "targets":[{"isStage":true,"name":"Stage","variables":{"`jEk@4|i[#Fk?(8x)AV.-my variable":["my variable",0]},"lists":{},"broadcasts":{},"blocks":{"?j7wn!kCjbUI~@L3(5.[":{"opcode":"cdg3v2_events_when_signal","next":"#s%83v5LHar;krs8W,qI","parent":null,"inputs":{},"fields":{},"shadow":false,"topLevel":true,"x":20,"y":45},"m~xYR;t=;I+NMoEtwv%0":{"opcode":"cdg3v2_events_no_ammo","next":"}nRRVfK}#nm{!9d4XLbJ","parent":null,"inputs":{},"fields":{},"shadow":false,"topLevel":true,"x":499,"y":44},"G=vvPsTrT9wj.Fi(7CH;":{"opcode":"cdg3v2_events_toxi_cluster","next":"cSEJx!5y3e-zQB+iqrXr","parent":null,"inputs":{},"fields":{},"shadow":false,"topLevel":true,"x":259,"y":44},"#s%83v5LHar;krs8W,qI":{"opcode":"cdg3v2_placeholder","next":null,"parent":"?j7wn!kCjbUI~@L3(5.[","inputs":{},"fields":{},"shadow":true,"topLevel":false},"cSEJx!5y3e-zQB+iqrXr":{"opcode":"cdg3v2_placeholder","next":null,"parent":"G=vvPsTrT9wj.Fi(7CH;","inputs":{},"fields":{},"shadow":true,"topLevel":false},"}nRRVfK}#nm{!9d4XLbJ":{"opcode":"cdg3v2_placeholder","next":null,"parent":"m~xYR;t=;I+NMoEtwv%0","inputs":{},"fields":{},"shadow":true,"topLevel":false}},"comments":{},"currentCostume":0,"costumes":[{"assetId":"cd21514d0531fdffb22204e0ec5ed84a","name":"backdrop1","md5ext":"cd21514d0531fdffb22204e0ec5ed84a.svg","dataFormat":"svg","rotationCenterX":240,"rotationCenterY":180}],"sounds":[{"assetId":"83a9787d4cb6f3b7632b4ddfebf74367","name":"pop","dataFormat":"wav","format":"","rate":44100,"sampleCount":1032,"md5ext":"83a9787d4cb6f3b7632b4ddfebf74367.wav"}],"volume":100,"tempo":60,"videoTransparency":50,"videoState":"on","textToSpeechLanguage":null}],"monitors":[],"extensions":[],"meta":{"semver":"3.0.0","vm":"0.7.9","agent":"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/98.0.4758.102 Safari/537.36"}},
    
    { "targets":[{"isStage":true,"name":"Stage","variables":{"`jEk@4|i[#Fk?(8x)AV.-my variable":["my variable",0]},"lists":{},"broadcasts":{},"blocks":{"+]p;eo-)+DC%dK)tzP*|":{"opcode":"cdg3v2_events_when_obstacle","next":"[Q~a,AfTs[W3?.[YZN8B","parent":null,"inputs":{},"fields":{},"shadow":false,"topLevel":true,"x":260,"y":56},".*R]{kA]iMScBT:dortA":{"opcode":"cdg3v2_events_when_pickup_close","next":"kcLb`g2zvg$*0*W]`%k]","parent":null,"inputs":{},"fields":{},"shadow":false,"topLevel":true,"x":498,"y":58},"?j7wn!kCjbUI~@L3(5.[":{"opcode":"cdg3v2_events_when_signal","next":"DR8C(=:d~5]{G2[HsLLq","parent":null,"inputs":{},"fields":{},"shadow":false,"topLevel":true,"x":10,"y":55},"DR8C(=:d~5]{G2[HsLLq":{"opcode":"cdg3v2_placeholder","next":null,"parent":"?j7wn!kCjbUI~@L3(5.[","inputs":{},"fields":{},"shadow":true,"topLevel":false},"[Q~a,AfTs[W3?.[YZN8B":{"opcode":"cdg3v2_placeholder","next":null,"parent":"+]p;eo-)+DC%dK)tzP*|","inputs":{},"fields":{},"shadow":true,"topLevel":false},"kcLb`g2zvg$*0*W]`%k]":{"opcode":"cdg3v2_placeholder","next":null,"parent":".*R]{kA]iMScBT:dortA","inputs":{},"fields":{},"shadow":true,"topLevel":false}},"comments":{},"currentCostume":0,"costumes":[{"assetId":"cd21514d0531fdffb22204e0ec5ed84a","name":"backdrop1","md5ext":"cd21514d0531fdffb22204e0ec5ed84a.svg","dataFormat":"svg","rotationCenterX":240,"rotationCenterY":180}],"sounds":[{"assetId":"83a9787d4cb6f3b7632b4ddfebf74367","name":"pop","dataFormat":"wav","format":"","rate":44100,"sampleCount":1032,"md5ext":"83a9787d4cb6f3b7632b4ddfebf74367.wav"}],"volume":100,"tempo":60,"videoTransparency":50,"videoState":"on","textToSpeechLanguage":null}],"monitors":[],"extensions":[],"meta":{"semver":"3.0.0","vm":"0.7.9","agent":"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/98.0.4758.102 Safari/537.36"} },
    
   {"targets":[{"isStage":true,"name":"Stage","variables":{"`jEk@4|i[#Fk?(8x)AV.-my variable":["my variable",0]},"lists":{},"broadcasts":{},"blocks":{".|0-p}(?(@maRM5|G=g`":{"opcode":"cdg3v2_events_when_pickup_close","next":"[DfxgHbvl5!!bI7Q,v52","parent":null,"inputs":{},"fields":{},"shadow":false,"topLevel":true,"x":739,"y":67},"[DfxgHbvl5!!bI7Q,v52":{"opcode":"cdg3v2_placeholder","next":null,"parent":".|0-p}(?(@maRM5|G=g`","inputs":{},"fields":{},"shadow":true,"topLevel":false},"9ZXpu[Eh({0ajRvgWgQR":{"opcode":"cdg3v2_events_toxi_cluster","next":",~OhbNf+oBh#-1wxUCP[","parent":null,"inputs":{},"fields":{},"shadow":false,"topLevel":true,"x":255,"y":63},",~OhbNf+oBh#-1wxUCP[":{"opcode":"cdg3v2_placeholder","next":null,"parent":"9ZXpu[Eh({0ajRvgWgQR","inputs":{},"fields":{},"shadow":true,"topLevel":false},"$.,NKkJf|tiLfFV5xf}x":{"opcode":"cdg3v2_events_when_obstacle","next":"oA;fEkGDreNSKt7HWf/-","parent":null,"inputs":{},"fields":{},"shadow":false,"topLevel":true,"x":976,"y":67},"oA;fEkGDreNSKt7HWf/-":{"opcode":"cdg3v2_placeholder","next":null,"parent":"$.,NKkJf|tiLfFV5xf}x","inputs":{},"fields":{},"shadow":true,"topLevel":false},"(Ps)#yCXlLfD~UiclB~p":{"opcode":"cdg3v2_events_no_ammo","next":"NQv-9uf+.SM,5d`yT^*=","parent":null,"inputs":{},"fields":{},"shadow":false,"topLevel":true,"x":501,"y":64},"NQv-9uf+.SM,5d`yT^*=":{"opcode":"cdg3v2_placeholder","next":null,"parent":"(Ps)#yCXlLfD~UiclB~p","inputs":{},"fields":{},"shadow":true,"topLevel":false},"2:zr_J4@o5x](5md5F*H":{"opcode":"cdg3v2_events_when_bird","next":"W?PQV6,]n0zw]c9T+j65","parent":null,"inputs":{},"fields":{},"shadow":false,"topLevel":true,"x":1217,"y":67},"W?PQV6,]n0zw]c9T+j65":{"opcode":"cdg3v2_placeholder","next":null,"parent":"2:zr_J4@o5x](5md5F*H","inputs":{},"fields":{},"shadow":true,"topLevel":false},"KN)#*$^cjUye;MOubz$!":{"opcode":"cdg3v2_events_when_signal","next":"$$CdTKe]VpxN)bIvjdCw","parent":null,"inputs":{},"fields":{},"shadow":false,"topLevel":true,"x":10,"y":55},"$$CdTKe]VpxN)bIvjdCw":{"opcode":"cdg3v2_placeholder","next":null,"parent":"KN)#*$^cjUye;MOubz$!","inputs":{},"fields":{},"shadow":true,"topLevel":false}},"comments":{},"currentCostume":0,"costumes":[{"assetId":"cd21514d0531fdffb22204e0ec5ed84a","name":"backdrop1","md5ext":"cd21514d0531fdffb22204e0ec5ed84a.svg","dataFormat":"svg","rotationCenterX":240,"rotationCenterY":180}],"sounds":[{"assetId":"83a9787d4cb6f3b7632b4ddfebf74367","name":"pop","dataFormat":"wav","format":"","rate":44100,"sampleCount":1032,"md5ext":"83a9787d4cb6f3b7632b4ddfebf74367.wav"}],"volume":100,"tempo":60,"videoTransparency":50,"videoState":"on","textToSpeechLanguage":null}],"monitors":[],"extensions":[],"meta":{"semver":"3.0.0","vm":"0.7.9","agent":"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/98.0.4758.102 Safari/537.36"}}

  ];
  

  const beatCheat = { "targets": [{ "isStage": true, "name": "Stage", "variables": { "`jEk@4|i[#Fk?(8x)AV.-my variable": ["my variable", 0] }, "lists": {}, "broadcasts": {}, "blocks": { "KN)#*$^cjUye;MOubz$!": { "opcode": "cdg3v2_events_when_signal", "next": "`S53s-fa.I$w=I%O-~;t", "parent": null, "inputs": {}, "fields": {}, "shadow": false, "topLevel": true, "x": 21, "y": 34 }, "`S53s-fa.I$w=I%O-~;t": { "opcode": "cdg3v2_action_jump_to_other_lane", "next": null, "parent": "KN)#*$^cjUye;MOubz$!", "inputs": {}, "fields": {}, "shadow": false, "topLevel": false }, ".|0-p}(?(@maRM5|G=g`": { "opcode": "cdg3v2_events_when_pickup_close", "next": ":GDg5?9**CQppJ?p@vDY", "parent": null, "inputs": {}, "fields": {}, "shadow": false, "topLevel": true, "x": 281, "y": 476 }, ":GDg5?9**CQppJ?p@vDY": { "opcode": "cdg3v2_action_drop", "next": null, "parent": ".|0-p}(?(@maRM5|G=g`", "inputs": {}, "fields": {}, "shadow": false, "topLevel": false }, "9ZXpu[Eh({0ajRvgWgQR": { "opcode": "cdg3v2_events_toxi_cluster", "next": ")f[tM/9d/3~o%*!p[5!I", "parent": null, "inputs": {}, "fields": {}, "shadow": false, "topLevel": true, "x": 290, "y": 44 }, ")f[tM/9d/3~o%*!p[5!I": { "opcode": "cdg3v2_action_switch_weapons", "next": null, "parent": "9ZXpu[Eh({0ajRvgWgQR", "inputs": {}, "fields": {}, "shadow": false, "topLevel": false }, "$.,NKkJf|tiLfFV5xf}x": { "opcode": "cdg3v2_events_when_obstacle", "next": "0S4RJ,Abdz,8-sv-B%e8", "parent": null, "inputs": {}, "fields": {}, "shadow": false, "topLevel": true, "x": 12, "y": 482 }, "0S4RJ,Abdz,8-sv-B%e8": { "opcode": "cdg3v2_action_hover", "next": null, "parent": "$.,NKkJf|tiLfFV5xf}x", "inputs": {}, "fields": {}, "shadow": false, "topLevel": false }, "(Ps)#yCXlLfD~UiclB~p": { "opcode": "cdg3v2_events_no_ammo", "next": "QNS9Q4?4#)5Yd88YIb-s", "parent": null, "inputs": {}, "fields": {}, "shadow": false, "topLevel": true, "x": 559, "y": 41 }, "QNS9Q4?4#)5Yd88YIb-s": { "opcode": "cdg3v2_action_switch_weapons", "next": null, "parent": "(Ps)#yCXlLfD~UiclB~p", "inputs": {}, "fields": {}, "shadow": false, "topLevel": false }, "2:zr_J4@o5x](5md5F*H": { "opcode": "cdg3v2_events_when_bird", "next": "iV4W9`qc`*a)Hiq5o71e", "parent": null, "inputs": {}, "fields": {}, "shadow": false, "topLevel": true, "x": 584, "y": 486 }, "iV4W9`qc`*a)Hiq5o71e": { "opcode": "cdg3v2_action_drop", "next": null, "parent": "2:zr_J4@o5x](5md5F*H", "inputs": {}, "fields": {}, "shadow": false, "topLevel": false } }, "comments": {}, "currentCostume": 0, "costumes": [{ "assetId": "cd21514d0531fdffb22204e0ec5ed84a", "name": "backdrop1", "md5ext": "cd21514d0531fdffb22204e0ec5ed84a.svg", "dataFormat": "svg", "rotationCenterX": 240, "rotationCenterY": 180 }], "sounds": [{ "assetId": "83a9787d4cb6f3b7632b4ddfebf74367", "name": "pop", "dataFormat": "wav", "format": "", "rate": 44100, "sampleCount": 1032, "md5ext": "83a9787d4cb6f3b7632b4ddfebf74367.wav" }], "volume": 100, "tempo": 60, "videoTransparency": 50, "videoState": "on", "textToSpeechLanguage": null }], "monitors": [], "extensions": [], "meta": { "semver": "3.0.0", "vm": "0.7.8", "agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/97.0.4692.71 Safari/537.36" } };
  const width = "100%";
  const height = "100%";
  const gameHeight = 600 / 3;
  const gameWidth = 960 / 3;

  let toolboxes;
  


  const dispatch = useDispatch();


  const mainWrapper = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    // margin: 50,
    height: window.innerHeight,
    width: window.innerWidth,
    overflow: 'hidden',
  }

  let toolboxUpdatetool = null;
  const UpdateWorkspaceSpace =
    useCallback(
      () => dispatch(updateToolbox(null), [dispatch]));

  useEffect(() => {
    if (vm.runtime.unity == undefined)
      return;
    if (isUnityFullScreen) {
      setUnityWidth(window.innerWidth);
      setUnityHeight(window.innerHeight);

    }
    window.vm = () => console.log(vm.toJSON());
    window.clearStore = () => clearStore();
    window.hackmyprogram = () => vm.loadProject(acclerationPrograms[1]);
    window.sample = () => vm.loadProject(acclerationPrograms[2]);
    window.latinTango = () => vm.loadProject(beatCityLatinMix);
    window.curtisSong = () => vm.loadProject(beatCheat);

    toolboxes = getToolboxes();
    clearStore();
   },
    [vm.runtime.unity])
  
  useEffect(() => {
    if (!blocklyWorkspace) {
      console.log("NO WORKSPACE");
      return;
    }
   },
    [blocklyWorkspace])
  

  const openPI = (event, /*(bot = 0, mode = "Fetch", is_mid_game = false*/) => {
    if (event.message.PROGRAM_INDEX != null) { 
      var programID = event.message.PROGRAM_INDEX;
      var songID = "cmra_song_id_" + event.message.SONG + "-" + programID;
     // console.log("blocklyWorkspace", blocklyWorkspace.getMainWorkspace().toolbox_.workspace_);
      //Blockly.getMainWorkspace().updateToolbox(getToolboxes[programID]);
      setToolbox(getToolboxes()[programID]);
     // toolboxWorkspaceContext.updateToolbox(makeP3GBayToolboxXML());
      //blocklyWorkspace.mainWorkspace.updateToolbox(makeP3GBayToolboxXML());
      // blocklyWorkspace.getFlyout().getWorkspace().updateToolbox(getToolboxes()[programID]);
        if (!localStorage.getItem(songID)) {
          // Program exists song.
          if (programID > beatCityPrograms.length - 1) {
            programID = 0;
          }
          vm.loadProject(beatCityPrograms[programID]);
          saveLocalProject(songID, JSON.stringify(beatCityPrograms[programID]));
        }
        else {
          vm.loadProject(getProject(songID));
        }
      console.log("Setting program key to", songID);
      setProgramKey(songID);

    }
    
    
    setUnityFullScreen(false);
    setUnityWidth(0);
    setUnityHeight(0);
    const message_outgoing = {
      topic: 'data_log',
      message: {
        method: 'browserLog',
        parameters: {
          ACTOR: "editor",
          VERB: "open",
          OBJECT: "blocks",
          program: JSON.stringify(vm.toJSON()).replace(/%/g, "$@$@")
        }
      }
    };
    const message_wrapper = JSON.stringify(message_outgoing);
    vm.runtime.unity.send('UnityMessenger', 'UnityMessengerDispatcher', message_wrapper);
  }


  const closePI = () => {
    
    if (isUnityFullScreen) {
      return;
    }
    if (vm.runtime.unity == undefined) {
      return;
    }
    if (blocklyWorkspace != null) {
      blocklyWorkspace.hideChaff();
    }
    const outgoing = {
      topic: 'game_status',
      message: {
          method: 'OnFocusUnity'
      }
    };
    const message = JSON.stringify(outgoing);
    vm.runtime.unity.send('UnityMessenger', 'UnityMessengerDispatcher', message);


    saveLocalProject(programKey, JSON.stringify(vm.toJSON()));
   // setHideBlockly(true);
    setUnityFullScreen(true);
    setUnityWidth(window.innerWidth);
    setUnityHeight(window.innerHeight);
    const outgoing2 = {
      topic: 'data_log',
      message: {
        method: 'browserLog',
        parameters: {
          ACTOR: "editor",
          VERB: "close",
          OBJECT: "blocks",
          program: JSON.stringify(vm.toJSON()).replace(/%/g, "$@$@")
        }
      }
    };
    const message2 = JSON.stringify(outgoing2);
    vm.runtime.unity.send('UnityMessenger', 'UnityMessengerDispatcher', message2);
  }

  const setWorkspace = (workspace) => {
    // if (workspace) {
    //   console.log("workspace", workspace);
    //   workspace.updateToolbox(getToolboxes[1]);
    // }
    setBlocklyWorkspace(workspace);
  }
  

  const cleanProgram = () => {
    dispatch(setProjectUnchanged());
  }
  const resetProgram = () => {
    var key = programKey;
    var prog = beatCityPrograms[programKey[programKey.length - 1]];
    console.log(programKey[programKey.length - 1]);
     vm.loadProject(prog).then(saveLocalProject(key, JSON.stringify(prog))).then(cleanProgram);
  }


  const getDropDownList = () => {
    return ["Follow Ball", "Follow Player"];
  }
  const onOptionClicked = value => () => {
    
    console.log(value, this);

    saveLocalProject(programKey, JSON.stringify(vm.toJSON()));
    setSelectedItem(value);
    setHideMenu(true);
  }
  const createNewPlaySession = () => {
    console.log("CONNECTING TO WEBSOCKETS...CREATING ANOTHER PLAY SESSION");
    
    connectWebSocket();
  }
 
  const loadDefaultProject = () => {
    console.log("TODO loading default");

    if (localStorage.getItem("Program0") == null) {
      saveLocalProject("Program0", JSON.stringify(beatCityPrograms[0]));
    }
    
    if (localStorage.getItem("Program1") == null) {
      saveLocalProject("Program1", JSON.stringify(beatCityPrograms[0]));
    }
   //console.log("Loading to vm ", JSON.parse(localStorage.getItem(fetch_key)));
    vm.loadProject(getProject("Program0")).then(cleanProgram);

  }
  const toolboxWorkspace = (workspace) => {
   // console.log(workspace);
   // setToolbox(workspace);
    
  }

  const playButton = () => {

   closePI();
  }
  const toggleDropdown = () => {
    setHideMenu(!hideMenu)
  }


  return (
    <div>
      <div style={mainWrapper}>
        
        <div className={styles.blocks_wrapper}>
              <Blocks
            canUseCloud={canUseCloud}
            workspace={setWorkspace}
            grow={1}
            isVisible={blocksTabVisible}
            options={{
              media: `${basePath}static/blocks-media/`
            }}
            stageSize={stageSizeMode}
            vm={vm}
            layout={layout}
            toolboxWorkspaceContext={setToolbox}
            tbXML={toolbox}
            
          />
           {/* <div className={styles.dropdown_wrapper}>
                  {
                    hideMenu ? 
                    <span><FaChevronCircleDown/></span>
                    :
                    <span><FaChevronCircleUp/></span>
                  }
                    <div className={styles.dropdown_header_wrapper}>
                      <label>Beastie's Programs</label>
                      <div className={styles.dropdown_header} onClick={toggleDropdown}>
                {
                getDropDownList()[selectedItem]
                }
                      </div>
                      {
                        modifiedBehavior ?
                        <div className={styles.modified_indicator}>Modified</div> :
                        null
                      }
                    </div>
                    {
                      hideMenu ? 
                      null :
                      <div className={styles.dropdown_list}>
                        {getDropDownList().map((program, index) => 
                      <div key={Math.random()} onClick={onOptionClicked(index)} className={styles.list_item}>
                        {program}
                      </div>
                    )}
                      </div>
                    }
          </div> */}
              
              <div onClick={playButton} className={styles.play_button}>
                <label>Play</label>
                <span><FaPlay className="fa-lg"/></span>
          </div>
          <div onClick={resetProgram} className={styles.reset_button}>
                  <span><VscDebugRestart /></span>
                </div>
          
        </div>

        <div onClick={() => {
          
          closePI();
        }} >
          <UnityPane loadDefaultProject={loadDefaultProject} width={unityWidth} height={unityHeight} isFullscreen={isUnityFullScreen} openPI={openPI} disableCS2N={true} createNewPlaySession={createNewPlaySession} />
          </div>
      </div>
      

   
    </div>
  )


  
}
